/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Section_Instagram_SummaryInputs */



/**
* | output |
* | --- |
* | "The account that publishes" |
*
* @param {Account_Section_Instagram_SummaryInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const account_section_instagram_summary = /** @type {((inputs?: Account_Section_Instagram_SummaryInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Section_Instagram_SummaryInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("The account that publishes")
	return /** @type {LocalizedString} */ ("Le compte qui publie")
});